import React, { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "./SliderLatestCollections.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  ACTIVE_LISTINGS_ALL,
  formatPrice,
  getNFTMetadata,
} from "../../../Features/Market/Market";
import { Certificate } from "../../../../assets";
import { useGraphQL } from "../../../../hooks/useGraphQL";
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { MARKET_ABI } from "../../../../contracts/contracts";
import { MARKET_ADDRESS } from "../../../Features/Market/Market";
import { useWallet } from "../../../../contexts/WalletContext";
import { useAuth } from "../../../../contexts/AuthContext";

const SliderLatestCollections = ({ autoplay = true, autoplaySpeed = 3000 }) => {
  const { ethAddress: walletAddress, provider } = useWallet();
  const { ethAddress: authEthAddress } = useAuth();
  const activeAddress = walletAddress || authEthAddress;

  const [latestItems, setLatestItems] = useState([]);
  const Navigate = useNavigate();
  const [showWalletModal, setShowWalletModal] = useState(false);

  const { data: dataListings } = useGraphQL(ACTIVE_LISTINGS_ALL);

  useEffect(() => {
    if (!dataListings?.listings?.length) return;

    const loadMetadata = async () => {
      try {
        const listings = dataListings.listings.slice(0, 5);
        const items = [];
        for (let i = 0; i < listings.length; i += 2) {
          const batch = listings.slice(i, i + 2);
          const batchResults = await Promise.all(
            batch.map(async (listing) => {
              const meta = await getNFTMetadata(listing.token?.metadataUri);
              return {
                type: "listing",
                id: listing.listingId,
                name: meta?.name || listing.token?.name || "",
                image: meta?.image || "",
                preview: meta?.preview || meta?.image || "",
                price: formatPrice(listing.pricePerToken),
                quantity: listing.quantity,
                collectionName: listing.token?.collection?.name || "",
              };
            }),
          );
          items.push(...batchResults);
        }
        setLatestItems(items);
      } catch (err) {
        console.error("Error loading artwork metadata", err);
      }
    };

    loadMetadata();
  }, [dataListings]);

  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      autoplay,
      autoplaySpeed,
      slidesToShow: 1,
      slidesToScroll: 1,
      customPaging: () => <div className="recustom-dot" />,
      responsive: [
        { breakpoint: 1024, settings: { arrows: false } },
        { breakpoint: 768, settings: { arrows: false, dots: true } },
      ],
    }),
    [autoplay, autoplaySpeed],
  );

  const handleDiscover = () => {
    Navigate("/reproduction");
  };

  const handleBuy = async (e) => {
    e.stopPropagation();
    if (!activeAddress) {
      toast.warn("⚠️ Please connect your wallet first!");
      setShowWalletModal(true);
      return;
    }
    try {
      const web3Provider = new ethers.BrowserProvider(
        provider || window.ethereum,
      );
      const signer = await web3Provider.getSigner();
      const contract = new ethers.Contract(MARKET_ADDRESS, MARKET_ABI, signer);
      const priceWei = ethers.parseEther(
        latestItems[0].price?.toString() || "0",
      );
      const balance = await web3Provider.getBalance(activeAddress);
      if (balance < priceWei) return toast.error("❌ Not enough ETH");
      const tx = await contract.buy(latestItems[0].id, 1, { value: priceWei });
      await tx.wait();
      toast.success("✅ Purchase successful!");
    } catch (err) {
      console.error("Purchase error:", err);
      toast.error("❌ Purchase failed!");
    }
  };

  return (
    <div className="reslider-container">
      <div className="sub-nav-links">
        <div className="sub-link2">Reproductions</div>
      </div>
      <Slider {...settings}>
        {latestItems.map((item, index) => {
          const imageSrc = item.preview || item.image;

          return (
            <div className="reslider-item" key={index}>
              <div
                className="reslider-image"
                style={{
                  backgroundImage: imageSrc
                    ? `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.35)), url(${imageSrc})`
                    : "none",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="reslider-thumbs">
                  <div className="reslider-thumbs-img1">
                    <img src={imageSrc} alt="" loading="eager" />
                  </div>
                  <div className="reslider-thumbs2">
                    <div
                      className="reslider-thumbs-img2"
                      style={{ backgroundImage: `url(${imageSrc})` }}
                    />
                    <div
                      className="reslider-thumbs-img3"
                      style={{ backgroundImage: `url(${imageSrc})` }}
                    />
                  </div>
                </div>

                <div className="reslider-top-right">
                  <div className="reprice-row">
                    <div>
                      <span className="relabel">Price</span>
                      <span className="reprice">{item.price} ETH</span>
                    </div>
                    <div>
                      <span className="relabel">Available Items</span>
                      <span className="reavailable">{item.quantity}</span>
                    </div>
                    <img src={Certificate} alt="" className="Certificate" />
                  </div>

                  <div className="reactions">
                    <button onClick={handleDiscover} className="rediscover-btn">
                      Discover the Collection
                    </button>

                    <button onClick={handleBuy} className="rerebuy-btn">
                      Get It
                    </button>
                  </div>
                </div>

                <div className="reslider-bottom-right">
                  <h3>{item.name}</h3>
                  <p>{item.collectionName}</p>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default SliderLatestCollections;
